// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.height-value {
  height: 35px !important;
}

.fuelUnit {
  height: 48px !important;
}

.price-cancel {
  text-decoration: line-through !important;
}

.scroll-content {
  padding-top: 10vh !important;
  background-color: transparent;
}

.toolbar-background {
  opacity: 0;
}

.toolbar-title-md {
  padding: 0px;
  font-size: 2rem;
}

.toolbar-md {
  padding: 0px;
  min-height: 56px;
}

.text-margin {
  margin-top: 3px !important;
  background-color: var(--ion-color-primary-contrast) !important;
}

.revision-text-margin {
  padding-left: 20px !important;
}

.revision-margin-bottom {
  margin-bottom: 12px !important;
}

.margin-top-width-left {
  margin-top: 10px !important;
}

.margin-top {
  margin-top: 10px !important;
}

.no-display {
  display: none !important;
}

.toolbar-ios ion-title {
  width: 100%;
  height: 100%;
  transform: translateZ(0);
  pointer-events: none;
}

.toolbar-ios {
  padding-top: 24px !important;
  padding-top: calc(constant(safe-area-inset-top) + 4px) !important;
  padding-top: calc(env(safe-area-inset-top) + 4px) !important;
  min-height: 64px !important;
  min-height: calc(44px + constant(safe-area-inset-top)) !important;
  min-height: calc(44px + env(safe-area-inset-top)) !important;
}

.toolbar-ios ion-title {
  padding: 0px !important;
}

.hint {
  font-size: 11px !important;
}

.toolbar-title {
  text-align: center !important;
  color: var(--ion-primary-text) !important;
}

.titleicon div {
  display: inline-block;
  margin-bottom: 10px;
}

.sub-total {
  margin-top: 10px !important;
}

.image-upload > input {
  display: none;
}

.toolbar-title-md {
  padding: 0px;
  font-size: 2rem;
}

.toolbar-md {
  padding: 0px;
  min-height: 56px;
}

.toolbar-ios ion-title {
  width: 100%;
  height: 100%;
  transform: translateZ(0);
  pointer-events: none;
}

.card-ios {
  margin-left: 5px !important;
  border-radius: 2px;
  width: calc(100% - 10px);
  font-size: 1.4rem;
  background: var(--ion-color-primary-contrast) !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.currencye {
  margin-top: 0px;
  position: absolute;
  right: 8px !important;
  font-size: 12px;
  color: var(--ion-color-step-550) !important;
}

.toolbar-ios {
  padding-top: 24px !important;
  padding-top: calc(constant(safe-area-inset-top) + 4px) !important;
  padding-top: calc(env(safe-area-inset-top) + 4px) !important;
  min-height: 64px !important;
  min-height: calc(44px + constant(safe-area-inset-top)) !important;
  min-height: calc(44px + env(safe-area-inset-top)) !important;
}

.toolbar-ios ion-title {
  padding: 0px !important;
}

animated-header ion-header ion-title.animate {
  opacity: 1 !important;
  transform: 0px !important;
}

.ios page-price-breakup .back-ground {
  background-color: var(--ion-color-primary-contrast) !important;
  margin-top: 0px !important;
}
.ios page-price-breakup ion-card {
  margin-top: 55px !important;
  height: 200px;
}

.android page-price-breakup .back-ground {
  background-color: var(--ion-color-primary-contrast) !important;
}
.android page-price-breakup ion-card {
  margin-top: 100px !important;
  height: 200px;
}

.md page-price-breakup .back-ground {
  background-color: var(--ion-color-primary-contrast) !important;
}
.md page-price-breakup ion-card {
  margin-top: 100px !important;
}
.md .border-btm {
  background-color: var(--ion-color-primary-contrast) !important;
}
.md .unitCss {
  margin-top: 8px;
  color: var(--ion-color-step-550) !important;
}

.carbonLableCss {
  margin-top: 5px;
}

[mt-3] {
  margin-top: -3px !important;
}

.carbonPriceCss {
  margin-top: 0px;
  padding-bottom: 7px;
  min-width: 14% !important;
}

.unitConversionCss {
  right: 7%;
  position: absolute;
}

[padding-left-10] {
  padding-left: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/price-rate-breakup/price-rate-breakup.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;;AACA;EACE,uBAAA;AAEF;;AAAA;EACE,wCAAA;AAGF;;AAAA;EACE,4BAAA;EACA,6BAAA;AAGF;;AAAA;EACE,UAAA;AAGF;;AAAA;EACE,YAAA;EACA,eAAA;AAGF;;AAAA;EACE,YAAA;EACA,gBAAA;AAGF;;AAAA;EAEE,0BAAA;EAGA,8DAAA;AAAF;;AAGA;EACE,6BAAA;AAAF;;AAGA;EACE,8BAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,wBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EAEA,wBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,4BAAA;EACA,iEAAA;EACA,4DAAA;EACA,2BAAA;EACA,iEAAA;EACA,4DAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,0BAAA;AAAF;;AAGA;EACE,6BAAA;EACA,yCAAA;AAAF;;AAGA;EACE,qBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,YAAA;EACA,eAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EAEA,wBAAA;EACA,oBAAA;AADF;;AAIA;EACE,2BAAA;EACA,kBAAA;EACA,wBAAA;EACA,iBAAA;EACA,wDAAA;EAEA,wCAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,2CAAA;AADF;;AAIA;EACE,4BAAA;EACA,iEAAA;EACA,4DAAA;EACA,2BAAA;EACA,iEAAA;EACA,4DAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAIA;EACE,qBAAA;EAEA,yBAAA;AADF;;AAMI;EACE,8DAAA;EACA,0BAAA;AAHN;AAMI;EACE,2BAAA;EACA,aAAA;AAJN;;AAWI;EACE,8DAAA;AARN;AAWI;EACE,4BAAA;EACA,aAAA;AATN;;AAgBI;EACE,8DAAA;AAbN;AAgBI;EACE,4BAAA;AAdN;AAkBE;EACE,8DAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,2CAAA;AAjBJ;;AAqBA;EAIE,eAAA;AArBF;;AAuBA;EACE,2BAAA;AApBF;;AAsBA;EACE,eAAA;EACA,mBAAA;EACA,yBAAA;AAnBF;;AAwBA;EACE,SAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,6BAAA;AArBF","sourcesContent":[".height-value {\n  height: 35px !important;\n}\n.fuelUnit {\n  height:48px !important;\n}\n.price-cancel {\n  text-decoration: line-through !important;\n}\n\n.scroll-content {\n  padding-top: 10vh !important;\n  background-color: transparent;\n}\n\n.toolbar-background {\n  opacity: 0;\n}\n\n.toolbar-title-md {\n  padding: 0px;\n  font-size: 2rem;\n}\n\n.toolbar-md {\n  padding: 0px;\n  min-height: 56px;\n}\n\n.text-margin {\n  // padding-top: 3px;\n  margin-top: 3px !important;\n  // padding-left: 10px !important;\n  // padding-right: 5px !important;\n  background-color: var(--ion-color-primary-contrast) !important;\n}\n\n.revision-text-margin {\n  padding-left: 20px !important;\n}\n\n.revision-margin-bottom {\n  margin-bottom: 12px !important;\n}\n\n.margin-top-width-left {\n  margin-top: 10px !important;\n}\n\n.margin-top {\n  margin-top: 10px !important;\n}\n\n.no-display {\n  display: none !important;\n}\n\n.toolbar-ios ion-title {\n  width: 100%;\n  height: 100%;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  pointer-events: none;\n}\n\n.toolbar-ios {\n  padding-top: calc(20px + 4px) !important;\n  padding-top: calc(constant(safe-area-inset-top) + 4px) !important;\n  padding-top: calc(env(safe-area-inset-top) + 4px) !important;\n  min-height: calc(44px + 20px) !important;\n  min-height: calc(44px + constant(safe-area-inset-top)) !important;\n  min-height: calc(44px + env(safe-area-inset-top)) !important;\n}\n\n.toolbar-ios ion-title {\n  padding: 0px !important;\n}\n\n.hint {\n  font-size: 11px !important;\n}\n\n.toolbar-title {\n  text-align: center !important;\n  color: var(--ion-primary-text) !important;\n}\n\n.titleicon div {\n  display: inline-block;\n  margin-bottom: 10px;\n}\n\n.sub-total {\n  margin-top: 10px !important;\n  // padding-right: 5px !important;\n}\n\n.image-upload > input {\n  display: none;\n}\n\n.toolbar-title-md {\n  padding: 0px;\n  font-size: 2rem;\n}\n\n.toolbar-md {\n  padding: 0px;\n  min-height: 56px;\n}\n\n.toolbar-ios ion-title {\n  width: 100%;\n  height: 100%;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  pointer-events: none;\n}\n\n.card-ios {\n  margin-left: 5px !important;\n  border-radius: 2px;\n  width: calc(100% - 10px);\n  font-size: 1.4rem;\n  background: var(--ion-color-primary-contrast) !important;\n  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.currencye {\n  margin-top: 0px;\n  position: absolute;\n  right: 8px !important;\n  font-size: 12px;\n  color: var(--ion-color-step-550) !important;\n}\n\n.toolbar-ios {\n  padding-top: calc(20px + 4px) !important;\n  padding-top: calc(constant(safe-area-inset-top) + 4px) !important;\n  padding-top: calc(env(safe-area-inset-top) + 4px) !important;\n  min-height: calc(44px + 20px) !important;\n  min-height: calc(44px + constant(safe-area-inset-top)) !important;\n  min-height: calc(44px + env(safe-area-inset-top)) !important;\n}\n\n.toolbar-ios ion-title {\n  padding: 0px !important;\n}\n\nanimated-header ion-header ion-title.animate {\n  opacity: 1 !important;\n  -webkit-transform: 0px !important;\n  transform: 0px !important;\n}\n\n.ios {\n  page-price-breakup {\n    .back-ground {\n      background-color: var(--ion-color-primary-contrast) !important;\n      margin-top: 0px !important;\n    }\n\n    ion-card {\n      margin-top: 55px !important;\n      height: 200px;\n    }\n  }\n}\n\n.android {\n  page-price-breakup {\n    .back-ground {\n      background-color: var(--ion-color-primary-contrast) !important;\n    }\n\n    ion-card {\n      margin-top: 100px !important;\n      height: 200px;\n    }\n  }\n}\n\n.md {\n  page-price-breakup {\n    .back-ground {\n      background-color: var(--ion-color-primary-contrast) !important;\n    }\n\n    ion-card {\n      margin-top: 100px !important;\n    }\n  }\n\n  .border-btm {\n    background-color: var(--ion-color-primary-contrast) !important;\n  }\n\n  .unitCss {\n    margin-top: 8px;\n    color: var(--ion-color-step-550) !important;\n  }\n}\n\n.carbonLableCss {\n  // text-align: center;\n  // position: absolute;\n  // left: 10%;\n  margin-top: 5px;\n}\n[mt-3] {\n  margin-top: -3px !important;\n}\n.carbonPriceCss {\n  margin-top: 0px;\n  padding-bottom: 7px;\n  min-width: 14% !important;\n  // position: absolute;\n  // left: 75%;\n}\n\n.unitConversionCss {\n  right: 7%;\n  position: absolute;\n}\n\n[padding-left-10] {\n  padding-left: 10px !important;\n}\n.rateCss {\n  &::part(native) {\n    // padding-left: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
